import { useSendDigilaPageViewEvent } from '@digila-ui/analytics/analytics'
import { useApplicationContext } from '@digila-ui/state/useApplicationContext'
import { StepType } from '@digila-ui/types'
import { useLanguage } from '@ui-common/hooks/useLanguage'
import { getEntranceStepTopBarProps } from '@ui-common/utils/helpers'
import { LogoIconType } from '@ui-components/global/ComponentProps'
import { EntranceStep as CommonEntranceStep } from '@ui-components/layout/EntranceStep'
import { ConfirmButtonProps } from '@ui-components/layout/WizardTypes'
import { JSX } from 'react'
import { useIntl } from 'react-intl'

import { DataProtection } from './components/DataProtection'
import { ServiceInfo } from './components/ServiceInfo'
import { getEntraceStepTranslations } from './translations'

export const EntranceStep = (): JSX.Element => {
  const intl = useIntl()
  const {
    confirmButtonLabel,
    introSection: { heading, leadText },
  } = getEntraceStepTranslations(intl.formatMessage)

  const { proceed, exit } = useApplicationContext()

  const { changeLanguage } = useLanguage()
  const topBarProps = getEntranceStepTopBarProps(intl, () => exit(), changeLanguage)

  const confirmButtonProps: ConfirmButtonProps = {
    confirmLabel: confirmButtonLabel,
    onConfirm: () => proceed({}),
  }

  useSendDigilaPageViewEvent(StepType.Entrance, false)

  return (
    <CommonEntranceStep
      icon={LogoIconType.SPankki}
      heading={heading}
      leadText={leadText}
      footerContent={<DataProtection />}
      mainContent={<ServiceInfo />}
      {...topBarProps}
      confirmButtonProps={confirmButtonProps}
    />
  )
}
